import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.91 10.09a2.7 2.7 0 1 1-3.819 3.82 2.7 2.7 0 0 1 3.818-3.82"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.25 12c0 .297.027.594.063.882l-1.588 1.242a.9.9 0 0 0-.224 1.156l1.412 2.443a.9.9 0 0 0 1.112.384l1.422-.571a.91.91 0 0 1 .846.099q.33.22.684.4c.27.137.466.382.509.682l.217 1.513c.063.442.442.77.888.77h2.817a.9.9 0 0 0 .888-.77l.217-1.512a.92.92 0 0 1 .512-.683q.353-.178.681-.396a.92.92 0 0 1 .85-.102l1.419.57a.9.9 0 0 0 1.112-.384l1.412-2.443a.9.9 0 0 0-.224-1.156l-1.588-1.242c.036-.288.063-.585.063-.882s-.027-.594-.063-.882l1.588-1.242a.9.9 0 0 0 .224-1.156l-1.412-2.443a.9.9 0 0 0-1.112-.384l-1.419.57a.92.92 0 0 1-.85-.102 7 7 0 0 0-.681-.396.92.92 0 0 1-.512-.683l-.216-1.512a.9.9 0 0 0-.888-.77h-2.817a.9.9 0 0 0-.888.77l-.218 1.514a.92.92 0 0 1-.509.682q-.354.181-.684.4a.92.92 0 0 1-.847.098l-1.421-.571a.9.9 0 0 0-1.112.384L3.501 8.72a.9.9 0 0 0 .224 1.156l1.588 1.242A7 7 0 0 0 5.25 12"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSettings;
